import React from "react";

import * as S from "./FilterBadges.styles";

type Props = {
  type?: string;
  onRemoveType: () => void;
  regions?: Array<string>;
  onRemoveRegion: (region: string) => void;
  plans?: Array<{ id: string; label: string }>;
  onRemovePlan: (planId: string) => void;
};

export const FilterBadges = (props: Props) => (
  <S.BadgeSection>
    {props.regions?.map(region => (
      <S.Badge key={region}>
        <span>{region}</span>
        <S.CloseButton
          onClick={() => {
            props.onRemoveRegion(region);
          }}
        />
      </S.Badge>
    ))}

    {props.type && (
      <S.Badge>
        <span>{props.type}</span>
        <S.CloseButton
          onClick={() => {
            props.onRemoveType();
          }}
        />
      </S.Badge>
    )}

    {props.plans?.map(plan => (
      <S.Badge key={plan.id}>
        <span>{plan.label}</span>
        <S.CloseButton
          onClick={() => {
            props.onRemovePlan(plan.id);
          }}
        />
      </S.Badge>
    ))}
  </S.BadgeSection>
);
